import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { downloadOutgoingCalls } from '../../actions/Calls';
import SortIcons from './../ProposalsSortIcons';
import TableRowOut from './TableRowOut';

const OutgoingCallsList = ({ calls, onSort, sortValue, user, onDelete, deleteMode, onRecover }) => {
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            <th
              className="cursor-pointer"
              onClick={() => calls.length > 0 && onSort('company[name]')}
            >
              Company Name <SortIcons sortObj={sortValue} sortName="company[name]" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => calls.length > 0 && onSort('callingNumber')}
            >
              Calling Number <SortIcons sortObj={sortValue} sortName="callingNumber" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => calls.length > 0 && onSort('virtualNumber')}
            >
              Virtual Number <SortIcons sortObj={sortValue} sortName="virtualNumber" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => calls.length > 0 && onSort('outgoingCid')}
            >
              Origination CID <SortIcons sortObj={sortValue} sortName="outgoingCid" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => calls.length > 0 && onSort('calledNumber')}
            >
              Called Number <SortIcons sortObj={sortValue} sortName="calledNumber" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => calls.length > 0 && onSort('duration')}
            >
              Duration <SortIcons sortObj={sortValue} sortName="duration" />
            </th>
            <th onClick={() => calls.length > 0 && onSort('date')}>
              Date
              <SortIcons sortObj={sortValue} sortName="date" />
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {calls.length ? (
            calls.map((item, i) => (
              <TableRowOut
                onRecover={onRecover}
                deleteMode={deleteMode}
                calls={item}
                key={i}
                user={user}
                onDelete={onDelete}
              />
            ))
          ) : (
            <tr>
              <td colSpan={8}>
                <Alert rowSpan={6} color="info">
                  No Calls Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  downloadOutgoingCalls: (token, callID) => dispatch(downloadOutgoingCalls(token, callID)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OutgoingCallsList);
